import React from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import { BrandUtil, BrandThemeProvider, PageLayerProvider } from 'dw-us-ui';
import styled from '@emotion/styled';
import HomePage from './pages/HomePage';

const MainContainer = styled.div`
	h3 {
		font-family: ${({ brandTag }) =>
			brandTag === 'law' ? 'Noto Serif' : 'georgia'};
	}
`;

const App = () => {
	const location = useLocation();
	const brand = BrandUtil.getBrand();
	const brandTag = BrandUtil.content(brand).tag.toLowerCase();
	return (
		<BrandThemeProvider brandTag={WEBPACK_BRAND_TAG}>
			<MainContainer brandTag={brandTag}>
				<PageLayerProvider>
					<Switch>
						<Route render={() => <HomePage pathName={location?.pathname} />} />
					</Switch>
				</PageLayerProvider>
			</MainContainer>
		</BrandThemeProvider>
	);
};

export default App;
